module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-12.c9d88bd7.JPG";